
define('text!responsive-gameday-loginiframe/src/templates/gd_loginiframe.tpl',[],function () { return '<iframe src="/account/partner/fb/gdlogin.jsp" width="100%" height="1000"></iframe>';});

